/*globals require */

import $ from "jquery";

$(
    (function () {
        $("[cjs-animation]").each((i, el) => {
            const animName = $(el).attr("cjs-animation");
            const autoPlay = ($(el).attr("cjs-autoplay") || "true").toLowerCase() === "true";
            const onlyPlayWhenOnScreen = ($(el).attr("cjs-off-screen") || "false").toLowerCase() !== "true";

            let animInst;

            let anim;
            try {
                anim = require(animName).default;
            } catch (e) {
                console.error(
                    `Couldn't load animation "${animName}". Make sure that it is built correctly and loaded into the HTML file.`,
                ); // eslint-disable-line
                return;
            }

            function canvasOnScreen() {
                if (!el.offsetWidth || !el.offsetHeight || !el.getClientRects().length) return false;
                const rect = el.getBoundingClientRect();
                if (rect.top + rect.height < 0) return false;
                if (rect.left + rect.width < 0) return false;
                if (rect.top > window.innerHeight) return false;
                if (rect.left > window.innerWidth) return false;
                return true;
            }

            anim.composition.getLibrary().properties.manifest.forEach((item) => {
                item.src = `./${animName}/${item.src}`;
            });

            Promise.all([
                anim.init(el).then((_animInst) => {
                    el.cjsAnimation = _animInst;
                    animInst = _animInst;
                    animInst.stage.setAutoPlay(autoPlay);
                    const oldUpdate = animInst.stage.update;
                    animInst.stage.update = function (evt) {
                        let interupt = false;
                        if (onlyPlayWhenOnScreen && !canvasOnScreen()) interupt = true;
                        if (interupt) return;
                        oldUpdate.call(this, evt);
                    };
                    $(el).trigger("cjs-ready");
                }),
                new Promise((resolve) => {
                    if (!$(el).is("[rm-scroll]")) {
                        resolve();
                    } else {
                        $(el).on("do-animation", () => resolve());
                    }
                }),
            ]).then(() => {
                if (!autoPlay)
                    setTimeout(() => {
                        animInst.stage.play();
                        el.__cjs_started__ = true;
                        $(el).trigger("cjs-started");
                    }, 250);
            });
        });
    })(),
);

export function cjsReady(el) {
    if (el.cjsAnimation) {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        $(el).on("cjs-ready", () => resolve());
    });
}

export function cjsStarted(el) {
    if (el.__cjs_started__) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        $(el).on("cjs-started", () => resolve());
    });
}

export function setStageVars(el, stageVars) {
    if (!el.cjsAnimation) {
        throw new Error("CJS Animation isn't ready yet!");
    }
    el.cjsAnimation.stage.stageVars = stageVars;
}
